import { render, staticRenderFns } from "./SchoolSignups.vue?vue&type=template&id=144701c2&scoped=true&"
import script from "./SchoolSignups.vue?vue&type=script&lang=js&"
export * from "./SchoolSignups.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSignups.vue?vue&type=style&index=0&id=144701c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144701c2",
  null
  
)

export default component.exports